import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';

interface Product {
  id: number;
  name: string;
  description: string;
  longDescription: string;
  image: string;
  category: string;
  features: string[];
  specifications: string[];
  usage: string[];
  images: string[];
}

const UrunDetayPage = () => {
  const { id } = useParams();
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);

  const products: Product[] = [
    {
      id: 1,
      name: 'Mistik Tarot Destesi',
      description: 'Özel tasarım 78 kartlık profesyonel tarot destesi. Altın yaldızlı, premium kalite.',
      longDescription: 'Mistik Tarot Destesi, spiritüel yolculuğunuzda size rehberlik edecek özenle tasarlanmış profesyonel bir tarot setidir. Her kart, derin sembolik anlamlar taşıyan özel illüstrasyonlarla süslenmiştir. Altın yaldızlı kenarları ve premium kaliteli kartonu ile uzun yıllar kullanabileceğiniz dayanıklı bir üründür.',
      image: 'https://public.readdy.ai/ai/img_res/eef5785bf541f78282f608733e51ebd1.jpg',
      category: 'Tarot Kartları',
      features: [
        '78 kartlık tam set (22 Major Arcana + 56 Minor Arcana)',
        'Altın yaldızlı kenarlar',
        'Premium kaliteli karton',
        'Özel tasarım illüstrasyonlar',
        'Lüks kadife kılıf dahil',
        'Türkçe kullanım kılavuzu',
        'Deniz Erin imzalı sertifika'
      ],
      specifications: [
        'Kart Boyutu: 7cm x 12cm',
        'Malzeme: Premium karton',
        'Kaplama: Mat laminasyon',
        'Kenar: Altın yaldız',
        'Ambalaj: Sert kutulu',
        'Ağırlık: 350gr'
      ],
      usage: [
        'Kartları ilk kullanımdan önce enerjinizle şarj edin',
        'Temiz ve sakin bir ortamda kullanın',
        'Her kullanımdan sonra kartları temizleyin',
        'Kadife kılıfında muhafaza edin',
        'Başkalarının dokunmasına izin vermeyin'
      ],
      images: [
        'https://readdy.ai/api/search-image?query=luxury%20mystical%20tarot%20cards%20deck%20with%20golden%20edges%20on%20elegant%20purple%20velvet%20fabric%20background%20professional%20product%20photography%20soft%20lighting%20spiritual%20and%20magical%20atmosphere%20high%20quality%20detailed%20cards%20with%20intricate%20designs%20Deniz%20Erin%20brand%20name%20visible%20on%20packaging&width=800&height=800&seq=tarot1det&orientation=squarish',
        'https://readdy.ai/api/search-image?query=tarot%20cards%20spread%20out%20showing%20detailed%20card%20designs%20golden%20edges%20mystical%20illustrations%20professional%20close%20up%20photography%20spiritual%20atmosphere%20Deniz%20Erin%20branding&width=800&height=800&seq=tarot1det2&orientation=squarish',
        'https://readdy.ai/api/search-image?query=luxury%20tarot%20card%20box%20packaging%20with%20velvet%20interior%20golden%20details%20elegant%20presentation%20Deniz%20Erin%20brand%20name%20professional%20product%20shot&width=800&height=800&seq=tarot1det3&orientation=squarish'
      ]
    },
    {
      id: 2,
      name: 'Ay Enerjisi Tarot Seti',
      description: 'Ay enerjileriyle uyumlu özel tarot kartları. Gümüş detaylı, kutulu set.',
      longDescription: 'Ay Enerjisi Tarot Seti, ay döngüleri ve lunar enerjilerle derin bağlantı kurmak için özel olarak tasarlanmıştır. Gümüş detayları ve ay fazlarını yansıtan özel illüstrasyonları ile benzersiz bir tarot deneyimi sunar. Dolunay ve yeniay ritüellerinizde kullanmak için idealdir.',
      image: 'https://readdy.ai/api/search-image?query=moon%20phases%20tarot%20cards%20with%20silver%20details%20on%20dark%20mystical%20background%20celestial%20themed%20deck%20professional%20product%20shot%20elegant%20packaging%20box%20spiritual%20moonlight%20atmosphere%20Deniz%20Erin%20brand%20name%20on%20box&width=800&height=800&seq=tarot2det&orientation=squarish',
      category: 'Tarot Kartları',
      features: [
        '78 kartlık ay temalı set',
        'Gümüş yaldızlı detaylar',
        'Ay fazları illüstrasyonları',
        'Celestial tasarım',
        'Özel kutulu ambalaj',
        'Ay ritüelleri rehberi',
        'Deniz Erin imzalı'
      ],
      specifications: [
        'Kart Boyutu: 7cm x 12cm',
        'Malzeme: Premium karton',
        'Kaplama: Parlak laminasyon',
        'Kenar: Gümüş yaldız',
        'Ambalaj: Özel kutulu',
        'Ağırlık: 380gr'
      ],
      usage: [
        'Ay döngülerine göre kullanın',
        'Dolunay ve yeniay ritüellerinde ideal',
        'Gece saatlerinde daha güçlü enerji',
        'Ay ışığında şarj edin',
        'Karanlık bir yerde saklayın'
      ],
      images: [
        'https://readdy.ai/api/search-image?query=moon%20phases%20tarot%20cards%20with%20silver%20details%20on%20dark%20mystical%20background%20celestial%20themed%20deck%20professional%20product%20shot%20elegant%20packaging%20box%20spiritual%20moonlight%20atmosphere%20Deniz%20Erin%20brand%20name%20on%20box&width=800&height=800&seq=tarot2det&orientation=squarish',
        'https://readdy.ai/api/search-image?query=celestial%20moon%20tarot%20cards%20spread%20showing%20lunar%20phases%20silver%20edges%20mystical%20night%20sky%20background%20Deniz%20Erin%20branding&width=800&height=800&seq=tarot2det2&orientation=squarish',
        'https://readdy.ai/api/search-image?query=moon%20tarot%20deck%20box%20with%20silver%20details%20elegant%20dark%20packaging%20celestial%20design%20Deniz%20Erin%20brand%20professional%20shot&width=800&height=800&seq=tarot2det3&orientation=squarish'
      ]
    },
    {
      id: 3,
      name: 'Ametist Meditasyon Küresi',
      description: 'Doğal ametist kristalinden üretilmiş meditasyon küresi. Ahşap standlı.',
      longDescription: 'Doğal ametist kristalinden özenle işlenmiş bu meditasyon küresi, yüksek titreşimli enerjisiyle meditasyon pratiğinizi derinleştirir. Ametist, zihinsel berraklık, spiritüel gelişim ve iç huzur için en güçlü kristallerden biridir. Ahşap standı ile birlikte gelen küre, hem meditasyon aracı hem de dekoratif bir eser olarak kullanılabilir.',
      image: 'https://readdy.ai/api/search-image?query=natural%20amethyst%20crystal%20sphere%20ball%20on%20wooden%20stand%20purple%20gemstone%20with%20inner%20clarity%20professional%20product%20photography%20on%20clean%20white%20background%20spiritual%20healing%20stone%20high%20quality%20detailed%20texture%20Deniz%20Erin%20brand%20label&width=800&height=800&seq=crystal1det&orientation=squarish',
      category: 'Kristaller',
      features: [
        '%100 doğal ametist kristal',
        'El işçiliği ile cilalanmış',
        'Yüksek berraklık',
        'Ahşap stand dahil',
        'Ortalama 8cm çap',
        'Her biri benzersiz',
        'Enerji temizliği yapılmış'
      ],
      specifications: [
        'Malzeme: Doğal ametist',
        'Çap: 7-9cm arası',
        'Ağırlık: 400-600gr',
        'Renk: Mor tonları',
        'Stand: Doğal ahşap',
        'Orijin: Brezilya'
      ],
      usage: [
        'Meditasyon sırasında elinizde tutun',
        'Üçüncü göz çakranıza yerleştirin',
        'Yatak odanızda bulundurun',
        'Ayda bir kez temizleyin',
        'Güneş ışığından uzak tutun'
      ],
      images: [
        'https://readdy.ai/api/search-image?query=natural%20amethyst%20crystal%20sphere%20ball%20on%20wooden%20stand%20purple%20gemstone%20with%20inner%20clarity%20professional%20product%20photography%20on%20clean%20white%20background%20spiritual%20healing%20stone%20high%20quality%20detailed%20texture%20Deniz%20Erin%20brand%20label&width=800&height=800&seq=crystal1det&orientation=squarish',
        'https://readdy.ai/api/search-image?query=amethyst%20sphere%20close%20up%20showing%20purple%20crystal%20formations%20inner%20beauty%20detailed%20texture%20Deniz%20Erin%20tag&width=800&height=800&seq=crystal1det2&orientation=squarish',
        'https://readdy.ai/api/search-image?query=amethyst%20crystal%20ball%20in%20meditation%20setting%20peaceful%20atmosphere%20spiritual%20energy%20Deniz%20Erin%20branding&width=800&height=800&seq=crystal1det3&orientation=squarish'
      ]
    },
    {
      id: 4,
      name: 'Gül Kuvars Şifa Taşı Seti',
      description: '7 parça gül kuvars şifa taşı seti. Çakra dengeleme için ideal.',
      longDescription: 'Gül Kuvars Şifa Taşı Seti, kalp çakranızı açmak ve sevgi enerjisini güçlendirmek için özel olarak hazırlanmıştır. 7 farklı boyutta gül kuvars taşı içeren bu set, çakra dengeleme, enerji şifası ve meditasyon çalışmalarınızda kullanabileceğiniz mükemmel bir araçtır. Her taş özenle seçilmiş ve enerji temizliği yapılmıştır.',
      image: 'https://readdy.ai/api/search-image?query=rose%20quartz%20healing%20stones%20set%20of%20seven%20pieces%20pink%20crystals%20arranged%20beautifully%20chakra%20balancing%20stones%20on%20soft%20fabric%20professional%20product%20photography%20gentle%20pink%20tones%20spiritual%20wellness%20atmosphere%20Deniz%20Erin%20brand%20packaging&width=800&height=800&seq=crystal2det&orientation=squarish',
      category: 'Kristaller',
      features: [
        '7 parça gül kuvars taşı',
        'Farklı boyutlarda',
        'Doğal ve işlenmemiş',
        'Kalp çakrası için ideal',
        'Sevgi enerjisi taşır',
        'Pamuklu kese dahil',
        'Kullanım rehberi'
      ],
      specifications: [
        'Malzeme: Doğal gül kuvars',
        'Parça Sayısı: 7 adet',
        'Boyut: 2-4cm arası',
        'Toplam Ağırlık: 150-200gr',
        'Renk: Pembe tonları',
        'Ambalaj: Pamuklu kese'
      ],
      usage: [
        'Kalp çakranıza yerleştirin',
        'Meditasyon sırasında tutun',
        'Yastığınızın altına koyun',
        'Banyoda kullanın',
        'Haftada bir temizleyin'
      ],
      images: [
        'https://readdy.ai/api/search-image?query=rose%20quartz%20healing%20stones%20set%20of%20seven%20pieces%20pink%20crystals%20arranged%20beautifully%20chakra%20balancing%20stones%20on%20soft%20fabric%20professional%20product%20photography%20gentle%20pink%20tones%20spiritual%20wellness%20atmosphere%20Deniz%20Erin%20brand%20packaging&width=800&height=800&seq=crystal2det&orientation=squarish',
        'https://readdy.ai/api/search-image?query=rose%20quartz%20stones%20close%20up%20showing%20natural%20pink%20crystal%20texture%20healing%20energy%20Deniz%20Erin%20label&width=800&height=800&seq=crystal2det2&orientation=squarish',
        'https://readdy.ai/api/search-image?query=rose%20quartz%20set%20in%20cotton%20pouch%20elegant%20presentation%20spiritual%20gift%20Deniz%20Erin%20branding&width=800&height=800&seq=crystal2det3&orientation=squarish'
      ]
    },
    {
      id: 5,
      name: 'Siyah Turmalin Koruma Taşı',
      description: 'Negatif enerjilere karşı güçlü koruma sağlayan doğal siyah turmalin.',
      longDescription: 'Siyah Turmalin, en güçlü koruma taşlarından biridir. Negatif enerjileri, elektromanyetik radyasyonu ve psişik saldırıları bloke eder. Doğal formunda sunulan bu taş, kök çakranızı güçlendirir ve topraklanmanıza yardımcı olur. Özellikle hassas kişiler ve enerji çalışması yapanlar için vazgeçilmez bir koruma aracıdır.',
      image: 'https://readdy.ai/api/search-image?query=natural%20black%20tourmaline%20protection%20stone%20raw%20crystal%20with%20deep%20black%20color%20professional%20product%20shot%20on%20neutral%20background%20powerful%20protective%20gemstone%20high%20quality%20mineral%20specimen%20Deniz%20Erin%20brand%20tag&width=800&height=800&seq=crystal3det&orientation=squarish',
      category: 'Kristaller',
      features: [
        'Doğal siyah turmalin',
        'Ham kristal formu',
        'Güçlü koruma enerjisi',
        'EMF koruması',
        'Topraklama etkisi',
        'Ortalama 5-7cm',
        'Her biri benzersiz'
      ],
      specifications: [
        'Malzeme: Doğal turmalin',
        'Boyut: 5-7cm',
        'Ağırlık: 80-120gr',
        'Renk: Siyah',
        'Form: Ham kristal',
        'Orijin: Brezilya'
      ],
      usage: [
        'Evinizin girişine yerleştirin',
        'Çalışma masanızda bulundurun',
        'Yanınızda taşıyın',
        'Elektronik cihazların yanına koyun',
        'Düzenli temizleyin'
      ],
      images: [
        'https://readdy.ai/api/search-image?query=natural%20black%20tourmaline%20protection%20stone%20raw%20crystal%20with%20deep%20black%20color%20professional%20product%20shot%20on%20neutral%20background%20powerful%20protective%20gemstone%20high%20quality%20mineral%20specimen%20Deniz%20Erin%20brand%20tag&width=800&height=800&seq=crystal3det&orientation=squarish',
        'https://readdy.ai/api/search-image?query=black%20tourmaline%20crystal%20close%20up%20showing%20natural%20formation%20protective%20energy%20dark%20mineral%20Deniz%20Erin%20label&width=800&height=800&seq=crystal3det2&orientation=squarish',
        'https://readdy.ai/api/search-image?query=black%20tourmaline%20in%20protective%20setting%20spiritual%20defense%20stone%20Deniz%20Erin%20branding&width=800&height=800&seq=crystal3det3&orientation=squarish'
      ]
    },
    {
      id: 6,
      name: 'Enerji Meditasyon Yastığı',
      description: 'Özel kumaştan üretilmiş, enerji çalışmaları için tasarlanmış meditasyon yastığı.',
      longDescription: 'Enerji Meditasyon Yastığı, uzun süreli meditasyon seanslarınızda konfor ve enerji desteği sağlamak için özel olarak tasarlanmıştır. İçindeki organik kabuğu dolgusu, vücudunuzun şeklini alarak mükemmel destek sunar. Mor ve altın renklerdeki mistik desenler, spiritüel enerjinizi yükseltir.',
      image: 'https://readdy.ai/api/search-image?query=luxury%20meditation%20cushion%20pillow%20in%20deep%20purple%20and%20gold%20colors%20spiritual%20healing%20energy%20design%20elegant%20fabric%20with%20mystical%20patterns%20professional%20product%20photography%20peaceful%20zen%20atmosphere%20Deniz%20Erin%20brand%20embroidery&width=800&height=800&seq=energy1det&orientation=squarish',
      category: 'Enerji Ürünleri',
      features: [
        'Ergonomik tasarım',
        'Organik kabuğu dolgusu',
        'Yıkanabilir kılıf',
        'Mistik desenli kumaş',
        'Mor ve altın renkler',
        'Taşıma sapı',
        'Deniz Erin nakışlı'
      ],
      specifications: [
        'Çap: 35cm',
        'Yükseklik: 15cm',
        'Dolgu: Organik kabuğu',
        'Kumaş: Premium pamuk',
        'Renk: Mor/Altın',
        'Ağırlık: 1.2kg'
      ],
      usage: [
        'Bağdaş kurarak oturun',
        'Kalçalarınızı yükseltin',
        'Omurganızı dik tutun',
        'Rahat nefes alın',
        'Kılıfı düzenli yıkayın'
      ],
      images: [
        'https://readdy.ai/api/search-image?query=luxury%20meditation%20cushion%20pillow%20in%20deep%20purple%20and%20gold%20colors%20spiritual%20healing%20energy%20design%20elegant%20fabric%20with%20mystical%20patterns%20professional%20product%20photography%20peaceful%20zen%20atmosphere%20Deniz%20Erin%20brand%20embroidery&width=800&height=800&seq=energy1det&orientation=squarish',
        'https://readdy.ai/api/search-image?query=meditation%20cushion%20in%20use%20person%20sitting%20peacefully%20zen%20atmosphere%20Deniz%20Erin%20branding%20visible&width=800&height=800&seq=energy1det2&orientation=squarish',
        'https://readdy.ai/api/search-image?query=meditation%20pillow%20detail%20showing%20mystical%20patterns%20and%20embroidery%20Deniz%20Erin%20brand&width=800&height=800&seq=energy1det3&orientation=squarish'
      ]
    },
    {
      id: 7,
      name: 'Premium Temizleme Seti',
      description: 'Beyaz adaçayı, palo santo ve lavanta içeren premium temizleme seti.',
      longDescription: 'Premium Temizleme Seti, mekanlarınızı ve enerjinizi arındırmak için ihtiyacınız olan her şeyi içerir. Beyaz adaçayı, palo santo ve lavanta gibi kutsal bitkiler, binlerce yıldır enerji temizliği için kullanılmaktadır. Bu set, evinizi, ofisinizi veya kendinizi negatif enerjilerden arındırmanın en doğal ve etkili yoludur.',
      image: 'https://readdy.ai/api/search-image?query=sage%20smudge%20stick%20bundle%20with%20palo%20santo%20and%20lavender%20spiritual%20cleansing%20set%20natural%20dried%20herbs%20on%20rustic%20wooden%20background%20professional%20product%20photography%20earthy%20tones%20peaceful%20atmosphere%20Deniz%20Erin%20brand%20label%20on%20packaging&width=800&height=800&seq=energy2det&orientation=squarish',
      category: 'Enerji Ürünleri',
      features: [
        'Beyaz adaçayı demeti',
        'Palo santo çubukları (3 adet)',
        'Lavanta demeti',
        'Seramik yakma kabı',
        'Tüy',
        'Kullanım rehberi',
        'Doğal ve organik'
      ],
      specifications: [
        'Adaçayı: 10cm',
        'Palo Santo: 10cm x 3 adet',
        'Lavanta: 15cm',
        'Kap: Seramik',
        'Tüy: Doğal',
        'Ambalaj: Kraft kutu'
      ],
      usage: [
        'Pencere ve kapıları açın',
        'Bitkiyi yakın',
        'Dumanı tüyle yayın',
        'Her odayı dolaşın',
        'Niyet belirleyin'
      ],
      images: [
        'https://readdy.ai/api/search-image?query=sage%20smudge%20stick%20bundle%20with%20palo%20santo%20and%20lavender%20spiritual%20cleansing%20set%20natural%20dried%20herbs%20on%20rustic%20wooden%20background%20professional%20product%20photography%20earthy%20tones%20peaceful%20atmosphere%20Deniz%20Erin%20brand%20label%20on%20packaging&width=800&height=800&seq=energy2det&orientation=squarish',
        'https://readdy.ai/api/search-image?query=smudging%20ceremony%20with%20sage%20smoke%20spiritual%20cleansing%20ritual%20Deniz%20Erin%20branding&width=800&height=800&seq=energy2det2&orientation=squarish',
        'https://readdy.ai/api/search-image?query=cleansing%20set%20contents%20arranged%20beautifully%20sage%20palo%20santo%20lavender%20Deniz%20Erin%20label&width=800&height=800&seq=energy2det3&orientation=squarish'
      ]
    },
    {
      id: 8,
      name: '7 Çakra Mum Seti',
      description: '7 çakraya özel renkli mumlar. Doğal balmumu ve esansiyel yağlar.',
      longDescription: '7 Çakra Mum Seti, her bir çakranıza özel olarak hazırlanmış renkli mumlardan oluşur. Doğal balmumundan üretilen bu mumlar, her çakraya uygun esansiyel yağlarla zenginleştirilmiştir. Meditasyon, yoga veya enerji çalışmalarınızda kullanarak çakralarınızı dengeleyebilir ve enerji akışınızı iyileştirebilirsiniz.',
      image: 'https://readdy.ai/api/search-image?query=seven%20chakra%20balancing%20candles%20in%20rainbow%20colors%20natural%20beeswax%20candles%20arranged%20in%20row%20spiritual%20healing%20atmosphere%20professional%20product%20shot%20colorful%20gradient%20from%20red%20to%20violet%20peaceful%20zen%20setting%20Deniz%20Erin%20brand%20on%20box&width=800&height=800&seq=energy3det&orientation=squarish',
      category: 'Enerji Ürünleri',
      features: [
        '7 renkli çakra mumu',
        'Doğal balmumu',
        'Esansiyel yağlı',
        'Her biri 8cm yükseklik',
        'Yaklaşık 20 saat yanma',
        'Çakra rehberi dahil',
        'Lüks kutulu'
      ],
      specifications: [
        'Malzeme: Doğal balmumu',
        'Adet: 7 mum',
        'Yükseklik: 8cm',
        'Çap: 5cm',
        'Yanma: 20 saat/mum',
        'Ambalaj: Özel kutu'
      ],
      usage: [
        'Çakra meditasyonunda kullanın',
        'Sırayla her çakra için yakın',
        'Niyetinizi belirleyin',
        'Güvenli yerde yakın',
        'Gözetimsiz bırakmayın'
      ],
      images: [
        'https://readdy.ai/api/search-image?query=seven%20chakra%20balancing%20candles%20in%20rainbow%20colors%20natural%20beeswax%20candles%20arranged%20in%20row%20spiritual%20healing%20atmosphere%20professional%20product%20shot%20colorful%20gradient%20from%20red%20to%20violet%20peaceful%20zen%20setting%20Deniz%20Erin%20brand%20on%20box&width=800&height=800&seq=energy3det&orientation=squarish',
        'https://readdy.ai/api/search-image?query=chakra%20candles%20burning%20in%20meditation%20setting%20peaceful%20spiritual%20atmosphere%20Deniz%20Erin%20branding&width=800&height=800&seq=energy3det2&orientation=squarish',
        'https://readdy.ai/api/search-image?query=seven%20chakra%20candles%20in%20luxury%20box%20colorful%20presentation%20Deniz%20Erin%20brand&width=800&height=800&seq=energy3det3&orientation=squarish'
      ]
    },
    {
      id: 9,
      name: 'Tarot Başlangıç Eğitim Seti',
      description: 'Başlangıç seviyesi tarot eğitimi için kapsamlı set. Kart destesi ve rehber kitap dahil.',
      longDescription: 'Tarot Başlangıç Eğitim Seti, tarot dünyasına adım atmak isteyenler için mükemmel bir başlangıç noktasıdır. Set, profesyonel bir tarot destesi, kapsamlı bir rehber kitap ve pratik yapabileceğiniz çalışma kartları içerir. Deniz Erin\'in 15 yıllık deneyiminden yararlanarak hazırlanan bu set, tarot okumayı adım adım öğrenmenizi sağlar.',
      image: 'https://readdy.ai/api/search-image?query=tarot%20reading%20education%20kit%20with%20cards%20and%20guidebook%20complete%20learning%20package%20on%20elegant%20purple%20background%20professional%20training%20materials%20mystical%20and%20educational%20atmosphere%20high%20quality%20product%20photography%20Deniz%20Erin%20brand%20on%20book%20cover&width=800&height=800&seq=edu1det&orientation=squarish',
      category: 'Eğitim Setleri',
      features: [
        '78 kartlık tarot destesi',
        '200 sayfa rehber kitap',
        'Çalışma kartları',
        'Örnek okuma şablonları',
        'Video eğitim erişimi',
        'Online destek grubu',
        'Sertifika programı'
      ],
      specifications: [
        'Kart: 78 adet',
        'Kitap: 200 sayfa',
        'Dil: Türkçe',
        'Seviye: Başlangıç',
        'Video: 10 saat',
        'Ambalaj: Lüks kutu'
      ],
      usage: [
        'Kitabı sırayla okuyun',
        'Her gün pratik yapın',
        'Video dersleri izleyin',
        'Destek grubuna katılın',
        'Günlük kart çekin'
      ],
      images: [
        'https://readdy.ai/api/search-image?query=tarot%20reading%20education%20kit%20with%20cards%20and%20guidebook%20complete%20learning%20package%20on%20elegant%20purple%20background%20professional%20training%20materials%20mystical%20and%20educational%20atmosphere%20high%20quality%20product%20photography%20Deniz%20Erin%20brand%20on%20book%20cover&width=800&height=800&seq=edu1det&orientation=squarish',
        'https://readdy.ai/api/search-image?query=tarot%20learning%20materials%20spread%20out%20guidebook%20cards%20worksheets%20educational%20Deniz%20Erin%20branding&width=800&height=800&seq=edu1det2&orientation=squarish',
        'https://readdy.ai/api/search-image?query=tarot%20education%20set%20in%20luxury%20box%20complete%20learning%20package%20Deniz%20Erin%20brand&width=800&height=800&seq=edu1det3&orientation=squarish'
      ]
    },
    {
      id: 10,
      name: 'Kristal Terapi Eğitim Seti',
      description: 'Kristal terapi eğitimi için gerekli tüm taşlar ve eğitim materyalleri.',
      longDescription: 'Kristal Terapi Eğitim Seti, kristal şifası öğrenmek isteyenler için kapsamlı bir eğitim paketidir. 15 farklı şifa kristali, detaylı eğitim kitabı, çakra haritası ve pratik yapabileceğiniz çalışma materyalleri içerir. Kristallerin enerji özelliklerini, kullanım yöntemlerini ve şifa tekniklerini öğrenerek profesyonel kristal terapisti olabilirsiniz.',
      image: 'https://readdy.ai/api/search-image?query=crystal%20healing%20education%20set%20with%20various%20gemstones%20and%20learning%20materials%20complete%20therapy%20training%20kit%20colorful%20crystals%20arranged%20beautifully%20professional%20product%20photography%20spiritual%20wellness%20theme%20Deniz%20Erin%20brand%20packaging&width=800&height=800&seq=edu2det&orientation=squarish',
      category: 'Eğitim Setleri',
      features: [
        '15 farklı şifa kristali',
        'Kristal terapi kitabı',
        'Çakra haritası',
        'Kristal tanıma kartları',
        'Temizleme rehberi',
        'Online video eğitim',
        'Uygulama sertifikası'
      ],
      specifications: [
        'Kristal: 15 çeşit',
        'Kitap: 150 sayfa',
        'Dil: Türkçe',
        'Video: 8 saat',
        'Sertifika: Evet',
        'Ambalaj: Ahşap kutu'
      ],
      usage: [
        'Kristalleri tanıyın',
        'Enerji özelliklerini öğrenin',
        'Temizleme yapın',
        'Şifa teknikleri uygulayın',
        'Pratik yapın'
      ],
      images: [
        'https://readdy.ai/api/search-image?query=crystal%20healing%20education%20set%20with%20various%20gemstones%20and%20learning%20materials%20complete%20therapy%20training%20kit%20colorful%20crystals%20arranged%20beautifully%20professional%20product%20photography%20spiritual%20wellness%20theme%20Deniz%20Erin%20brand%20packaging&width=800&height=800&seq=edu2det&orientation=squarish',
        'https://readdy.ai/api/search-image?query=crystal%20therapy%20learning%20materials%20crystals%20guidebook%20chakra%20chart%20Deniz%20Erin%20branding&width=800&height=800&seq=edu2det2&orientation=squarish',
        'https://readdy.ai/api/search-image?query=crystal%20healing%20set%20in%20wooden%20box%20complete%20education%20package%20Deniz%20Erin%20brand&width=800&height=800&seq=edu2det3&orientation=squarish'
      ]
    },
    {
      id: 11,
      name: 'Meditasyon Başlangıç Seti',
      description: 'Meditasyon pratiği için özel tasarlanmış kapsamlı başlangıç seti.',
      longDescription: 'Meditasyon Başlangıç Seti, meditasyon yolculuğunuza başlamak için ihtiyacınız olan her şeyi içerir. Meditasyon yastığı, Tibet çanı, mala, kristaller ve kapsamlı rehber kitap ile meditasyon pratiğinizi derinleştirebilirsiniz. Deniz Erin\'in rehberliğinde hazırlanan bu set, günlük meditasyon alışkanlığı kazanmanıza yardımcı olur.',
      image: 'https://readdy.ai/api/search-image?query=meditation%20and%20mindfulness%20starter%20kit%20with%20cushion%20singing%20bowl%20and%20crystals%20complete%20zen%20practice%20set%20peaceful%20purple%20and%20gold%20tones%20professional%20product%20photography%20serene%20spiritual%20atmosphere%20Deniz%20Erin%20brand%20label&width=800&height=800&seq=edu3det&orientation=squarish',
      category: 'Eğitim Setleri',
      features: [
        'Meditasyon yastığı',
        'Tibet çanı',
        '108 taneli mala',
        'Meditasyon kristalleri',
        'Rehber kitap',
        'Ses meditasyonları (USB)',
        'Online destek'
      ],
      specifications: [
        'Yastık: 35cm çap',
        'Çan: El yapımı Tibet',
        'Mala: 108 boncuk',
        'Kristal: 3 adet',
        'Kitap: 120 sayfa',
        'Ambalaj: Lüks kutu'
      ],
      usage: [
        'Rahat bir yer seçin',
        'Yastığa oturun',
        'Çanı çalın',
        'Nefes egzersizi yapın',
        'Günlük pratik edin'
      ],
      images: [
        'https://readdy.ai/api/search-image?query=meditation%20and%20mindfulness%20starter%20kit%20with%20cushion%20singing%20bowl%20and%20crystals%20complete%20zen%20practice%20set%20peaceful%20purple%20and%20gold%20tones%20professional%20product%20photography%20serene%20spiritual%20atmosphere%20Deniz%20Erin%20brand%20label&width=800&height=800&seq=edu3det&orientation=squarish',
        'https://readdy.ai/api/search-image?query=meditation%20kit%20contents%20arranged%20peacefully%20cushion%20bowl%20mala%20crystals%20Deniz%20Erin%20branding&width=800&height=800&seq=edu3det2&orientation=squarish',
        'https://readdy.ai/api/search-image?query=meditation%20starter%20set%20in%20luxury%20packaging%20complete%20zen%20kit%20Deniz%20Erin%20brand&width=800&height=800&seq=edu3det3&orientation=squarish'
      ]
    },
    {
      id: 12,
      name: 'Ay Ritüelleri Lüks Koleksiyon',
      description: 'Dolunay ve yeniay ritüelleri için özel hazırlanmış lüks koleksiyon seti.',
      longDescription: 'Ay Ritüelleri Lüks Koleksiyon, ay döngüleriyle uyumlu çalışmak isteyenler için özel olarak hazırlanmış premium bir settir. Gümüş detaylı mumlar, ay taşları, ritüel araçları ve kapsamlı ay ritüelleri rehberi içerir. Her dolunay ve yeniayda güçlü ritüeller yaparak niyetlerinizi gerçekleştirebilir ve hayatınızı dönüştürebilirsiniz.',
      image: 'https://readdy.ai/api/search-image?query=luxury%20moon%20ritual%20collection%20set%20with%20candles%20crystals%20and%20ceremonial%20items%20elegant%20mystical%20package%20in%20silver%20and%20purple%20professional%20product%20photography%20celestial%20spiritual%20atmosphere%20premium%20quality%20Deniz%20Erin%20brand%20on%20luxury%20box&width=800&height=800&seq=special1det&orientation=squarish',
      category: 'Özel Koleksiyonlar',
      features: [
        'Gümüş detaylı mumlar',
        'Ay taşları koleksiyonu',
        'Ritüel araçları',
        'Ay suyu şişesi',
        'Niyet kağıtları',
        'Ay ritüelleri kitabı',
        'Lüks gümüş kutulu'
      ],
      specifications: [
        'Mum: 2 adet (gümüş)',
        'Kristal: 5 ay taşı',
        'Şişe: Cam 100ml',
        'Kitap: 80 sayfa',
        'Kağıt: 50 adet',
        'Ambalaj: Gümüş kutu'
      ],
      usage: [
        'Ay takvimini takip edin',
        'Dolunay ritüeli yapın',
        'Yeniay niyeti belirleyin',
        'Ay suyu hazırlayın',
        'Düzenli pratik edin'
      ],
      images: [
        'https://readdy.ai/api/search-image?query=luxury%20moon%20ritual%20collection%20set%20with%20candles%20crystals%20and%20ceremonial%20items%20elegant%20mystical%20package%20in%20silver%20and%20purple%20professional%20product%20photography%20celestial%20spiritual%20atmosphere%20premium%20quality%20Deniz%20Erin%20brand%20on%20luxury%20box&width=800&height=800&seq=special1det&orientation=squarish',
        'https://readdy.ai/api/search-image?query=moon%20ritual%20items%20arranged%20beautifully%20silver%20candles%20crystals%20ceremonial%20tools%20Deniz%20Erin%20branding&width=800&height=800&seq=special1det2&orientation=squarish',
        'https://readdy.ai/api/search-image?query=luxury%20moon%20ritual%20set%20in%20silver%20box%20premium%20celestial%20collection%20Deniz%20Erin%20brand&width=800&height=800&seq=special1det3&orientation=squarish'
      ]
    },
    {
      id: 13,
      name: 'Bolluk ve Bereket Seti',
      description: 'Bolluk ve bereket çalışmaları için altın enerjili özel set.',
      longDescription: 'Bolluk ve Bereket Seti, finansal bolluk ve hayatınızın her alanında bereket çekmek için özel olarak hazırlanmıştır. Altın renkli mumlar, sitrin ve yeşil aventurin gibi bolluk kristalleri, bereket affirmasyonları ve manifestasyon araçları içerir. Bu güçlü set ile bolluk bilincini aktive edebilir ve hayallerinizi gerçekleştirebilirsiniz.',
      image: 'https://readdy.ai/api/search-image?query=golden%20manifestation%20abundance%20set%20with%20citrine%20crystals%20and%20gold%20candles%20luxury%20spiritual%20prosperity%20kit%20warm%20golden%20tones%20professional%20product%20photography%20wealth%20and%20success%20energy%20theme%20Deniz%20Erin%20brand%20emblem&width=800&height=800&seq=special2det&orientation=squarish',
      category: 'Özel Koleksiyonlar',
      features: [
        'Altın renkli mumlar',
        'Sitrin kristali',
        'Yeşil aventurin',
        'Bolluk affirmasyonları',
        'Manifestasyon defteri',
        'Bereket ritüeli rehberi',
        'Altın kutulu'
      ],
      specifications: [
        'Mum: 3 adet (altın)',
        'Sitrin: 1 adet büyük',
        'Aventurin: 1 adet',
        'Defter: 100 sayfa',
        'Kart: 30 affırmasyon',
        'Ambalaj: Altın kutu'
      ],
      usage: [
        'Bolluk niyeti belirleyin',
        'Günlük affırmasyon yapın',
        'Kristalleri taşıyın',
        'Manifestasyon yazın',
        'Şükür pratiği yapın'
      ],
      images: [
        'https://readdy.ai/api/search-image?query=golden%20manifestation%20abundance%20set%20with%20citrine%20crystals%20and%20gold%20candles%20luxury%20spiritual%20prosperity%20kit%20warm%20golden%20tones%20professional%20product%20photography%20wealth%20and%20success%20energy%20theme%20Deniz%20Erin%20brand%20emblem&width=800&height=800&seq=special2det&orientation=squarish',
        'https://readdy.ai/api/search-image?query=abundance%20set%20contents%20golden%20candles%20citrine%20crystals%20manifestation%20tools%20Deniz%20Erin%20branding&width=800&height=800&seq=special2det2&orientation=squarish',
        'https://readdy.ai/api/search-image?query=prosperity%20set%20in%20golden%20box%20luxury%20abundance%20collection%20Deniz%20Erin%20brand&width=800&height=800&seq=special2det3&orientation=squarish'
      ]
    },
    {
      id: 14,
      name: 'Koruma ve Arınma Koleksiyonu',
      description: 'Negatif enerjilerden korunma ve arınma için güçlü ürün koleksiyonu.',
      longDescription: 'Koruma ve Arınma Koleksiyonu, negatif enerjilerden, kötü niyetlerden ve psişik saldırılardan korunmak için en güçlü araçları bir araya getirir. Siyah turmalin, obsidyen, koruma mumlari, adaçayı ve koruma duaları içeren bu set, enerji kalkınızı güçlendirir ve aura temizliği yapmanızı sağlar.',
      image: 'https://readdy.ai/api/search-image?query=protection%20and%20cleansing%20collection%20with%20black%20tourmaline%20sage%20and%20protective%20amulets%20spiritual%20defense%20kit%20on%20dark%20mystical%20background%20professional%20product%20shot%20powerful%20energy%20atmosphere%20Deniz%20Erin%20brand%20seal&width=800&height=800&seq=special3det&orientation=squarish',
      category: 'Özel Koleksiyonlar',
      features: [
        'Siyah turmalin kristali',
        'Obsidyen taşı',
        'Koruma mumları',
        'Adaçayı demeti',
        'Koruma nazarlığı',
        'Koruma duaları kitapçığı',
        'Siyah kutulu'
      ],
      specifications: [
        'Turmalin: 1 büyük',
        'Obsidyen: 1 adet',
        'Mum: 3 siyah',
        'Adaçayı: 2 demet',
        'Nazarlık: El yapımı',
        'Ambalaj: Siyah kutu'
      ],
      usage: [
        'Evinizi koruyun',
        'Düzenli temizlik yapın',
        'Kristalleri taşıyın',
        'Koruma duası okuyun',
        'Enerji kalkınızı güçlendirin'
      ],
      images: [
        'https://readdy.ai/api/search-image?query=protection%20and%20cleansing%20collection%20with%20black%20tourmaline%20sage%20and%20protective%20amulets%20spiritual%20defense%20kit%20on%20dark%20mystical%20background%20professional%20product%20shot%20powerful%20energy%20atmosphere%20Deniz%20Erin%20brand%20seal&width=800&height=800&seq=special3det&orientation=squarish',
        'https://readdy.ai/api/search-image?query=protection%20set%20contents%20black%20crystals%20sage%20protective%20items%20Deniz%20Erin%20branding&width=800&height=800&seq=special3det2&orientation=squarish',
        'https://readdy.ai/api/search-image?query=spiritual%20protection%20collection%20in%20black%20box%20powerful%20defense%20kit%20Deniz%20Erin%20brand&width=800&height=800&seq=special3det3&orientation=squarish'
      ]
    },
    {
      id: 15,
      name: 'Aşk ve İlişki Enerji Seti',
      description: 'Kalp çakrası ve aşk enerjisi çalışmaları için özel tasarlanmış romantik set.',
      longDescription: 'Aşk ve İlişki Enerji Seti, kalp çakranızı açmak, aşk enerjisini çekmek ve ilişkilerinizi güçlendirmek için özel olarak hazırlanmıştır. Gül kuvars, rodonit, pembe mumlar, aşk affirmasyonları ve ilişki ritüelleri içerir. Kendinizi sevmeyi öğrenmek, ruh eşinizi çekmek veya mevcut ilişkinizi derinleştirmek için idealdir.',
      image: 'https://readdy.ai/api/search-image?query=love%20and%20relationship%20energy%20set%20with%20rose%20quartz%20and%20pink%20candles%20romantic%20spiritual%20kit%20in%20soft%20pink%20tones%20heart%20chakra%20healing%20products%20professional%20product%20photography%20gentle%20loving%20atmosphere%20Deniz%20Erin%20brand%20on%20elegant%20box&width=800&height=800&seq=special4det&orientation=squarish',
      category: 'Özel Koleksiyonlar',
      features: [
        'Gül kuvars kalp',
        'Rodonit taşı',
        'Pembe mumlar',
        'Aşk affirmasyonları',
        'İlişki ritüelleri kitabı',
        'Gül yaprakları',
        'Pembe kutulu'
      ],
      specifications: [
        'Gül Kuvars: Kalp şekli',
        'Rodonit: 1 adet',
        'Mum: 3 pembe',
        'Kitap: 60 sayfa',
        'Gül: Kurutulmuş',
        'Ambalaj: Pembe kutu'
      ],
      usage: [
        'Kalp çakrası meditasyonu',
        'Aşk affirmasyonları',
        'İlişki ritüeli yapın',
        'Kristalleri taşıyın',
        'Kendinizi sevin'
      ],
      images: [
        'https://readdy.ai/api/search-image?query=love%20and%20relationship%20energy%20set%20with%20rose%20quartz%20and%20pink%20candles%20romantic%20spiritual%20kit%20in%20soft%20pink%20tones%20heart%20chakra%20healing%20products%20professional%20product%20photography%20gentle%20loving%20atmosphere%20Deniz%20Erin%20brand%20on%20elegant%20box&width=800&height=800&seq=special4det&orientation=squarish',
        'https://readdy.ai/api/search-image?query=love%20energy%20set%20contents%20rose%20quartz%20heart%20pink%20candles%20romantic%20items%20Deniz%20Erin%20branding&width=800&height=800&seq=special4det2&orientation=squarish',
        'https://readdy.ai/api/search-image?query=relationship%20energy%20collection%20in%20pink%20box%20romantic%20spiritual%20set%20Deniz%20Erin%20brand&width=800&height=800&seq=special4det3&orientation=squarish'
      ]
    }
  ];

  const product = products.find(p => p.id === Number(id));

  if (!product) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <div className="pt-32 pb-20 px-6 text-center">
          <h1 className="text-3xl font-bold text-primary-dark mb-4">Ürün Bulunamadı</h1>
          <Link to="/urunler" className="text-gold hover:underline cursor-pointer">
            Ürünlere Dön
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const handleWhatsAppOrder = () => {
    const message = `Merhaba, ${product.name} ürünü hakkında bilgi almak ve sipariş vermek istiyorum. Adet: ${quantity}`;
    const whatsappUrl = `https://wa.me/905366460317?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const whatsappMessage = `Merhaba, ${product.name} hakkında bilgi almak istiyorum.`;
  const whatsappUrl = `https://wa.me/905555555555?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Breadcrumb */}
      <section className="pt-32 pb-8 px-6 bg-cream">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <Link to="/" className="hover:text-gold transition-colors cursor-pointer">Ana Sayfa</Link>
            <span>/</span>
            <Link to="/urunler" className="hover:text-gold transition-colors cursor-pointer">Ürünler</Link>
            <span>/</span>
            <span className="text-primary-dark">{product.name}</span>
          </div>
        </div>
      </section>

      {/* Product Detail */}
      <section className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Images */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              {/* Main Image */}
              <div className="relative w-full h-[500px] rounded-2xl overflow-hidden bg-gray-100 mb-4">
                <img
                  src={product.images[selectedImage]}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Thumbnail Images */}
              <div className="grid grid-cols-3 gap-4">
                {product.images.map((image, index) => (
                  <button
                    key={index}
                    onClick={() => setSelectedImage(index)}
                    className={`relative w-full h-32 rounded-lg overflow-hidden bg-gray-100 cursor-pointer transition-all duration-300 ${
                      selectedImage === index ? 'ring-4 ring-gold' : 'hover:ring-2 hover:ring-gold/50'
                    }`}
                  >
                    <img
                      src={image}
                      alt={`${product.name} ${index + 1}`}
                      className="w-full h-full object-cover object-top"
                    />
                  </button>
                ))}
              </div>
            </motion.div>

            {/* Product Info */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="mb-4">
                <span className="inline-block px-4 py-1.5 bg-purple-100 text-purple-700 rounded-full text-sm font-medium">
                  {product.category}
                </span>
              </div>

              <h1 className="font-serif text-4xl lg:text-5xl font-bold text-primary-dark mb-4">
                {product.name}
              </h1>

              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                {product.description}
              </p>

              <div className="bg-cream rounded-2xl p-6 mb-6">
                <p className="text-text-medium leading-relaxed">
                  {product.longDescription}
                </p>
              </div>

              {/* Quantity Selector */}
              <div className="flex items-center space-x-4 mb-8">
                <span className="text-text-medium font-medium">Adet:</span>
                <div className="flex items-center space-x-3">
                  <button
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                    className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gold hover:text-white transition-all duration-300 cursor-pointer"
                  >
                    <i className="ri-subtract-line"></i>
                  </button>
                  <span className="w-12 text-center font-semibold text-lg">{quantity}</span>
                  <button
                    onClick={() => setQuantity(quantity + 1)}
                    className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gold hover:text-white transition-all duration-300 cursor-pointer"
                  >
                    <i className="ri-add-line"></i>
                  </button>
                </div>
              </div>

              {/* WhatsApp Order Button */}
              <a
                href={whatsappUrl}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="flex items-center justify-center space-x-3 w-full py-4 bg-green-600 text-white rounded-full text-lg font-semibold hover:bg-green-700 hover:shadow-2xl transition-all duration-300 cursor-pointer whitespace-nowrap mb-4"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                <span>WhatsApp ile Sipariş Ver</span>
              </a>

              <Link
                to="/randevu"
                className="flex items-center justify-center space-x-2 w-full py-4 border-2 border-primary-dark text-primary-dark rounded-full text-lg font-semibold hover:bg-primary-dark hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-calendar-line"></i>
                <span>Randevu Al</span>
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Product Details Tabs */}
      <section className="py-16 px-6 bg-cream">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Features */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="bg-white rounded-2xl p-8"
            >
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center">
                  <i className="ri-star-line text-gold text-xl"></i>
                </div>
                <h3 className="font-serif text-2xl font-bold text-primary-dark">Özellikler</h3>
              </div>
              <ul className="space-y-3">
                {product.features.map((feature, index) => (
                  <li key={index} className="flex items-start space-x-2 text-text-medium">
                    <i className="ri-check-line text-gold mt-1 flex-shrink-0"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Specifications */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="bg-white rounded-2xl p-8"
            >
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center">
                  <i className="ri-file-list-line text-gold text-xl"></i>
                </div>
                <h3 className="font-serif text-2xl font-bold text-primary-dark">Teknik Özellikler</h3>
              </div>
              <ul className="space-y-3">
                {product.specifications.map((spec, index) => (
                  <li key={index} className="flex items-start space-x-2 text-text-medium">
                    <i className="ri-arrow-right-s-line text-gold mt-1 flex-shrink-0"></i>
                    <span>{spec}</span>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Usage */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-white rounded-2xl p-8"
            >
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center">
                  <i className="ri-lightbulb-line text-gold text-xl"></i>
                </div>
                <h3 className="font-serif text-2xl font-bold text-primary-dark">Kullanım Önerileri</h3>
              </div>
              <ul className="space-y-3">
                {product.usage.map((tip, index) => (
                  <li key={index} className="flex items-start space-x-2 text-text-medium">
                    <i className="ri-information-line text-gold mt-1 flex-shrink-0"></i>
                    <span>{tip}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Related Products */}
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="font-serif text-4xl font-bold text-primary-dark mb-4">
              Benzer Ürünler
            </h2>
            <p className="text-text-medium text-lg">
              İlginizi çekebilecek diğer ürünler
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {products
              .filter(p => p.category === product.category && p.id !== product.id)
              .slice(0, 3)
              .map((relatedProduct, index) => (
                <motion.div
                  key={relatedProduct.id}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                >
                  <Link
                    to={`/urunler/${relatedProduct.id}`}
                    className="block bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer"
                  >
                    <div className="relative w-full h-80 overflow-hidden bg-gray-100">
                      <img
                        src={relatedProduct.image}
                        alt={relatedProduct.name}
                        className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-6">
                      <span className="inline-block px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-medium mb-3">
                        {relatedProduct.category}
                      </span>
                      <h3 className="font-serif text-xl font-bold text-primary-dark mb-3 group-hover:text-gold transition-colors duration-300">
                        {relatedProduct.name}
                      </h3>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        {relatedProduct.description}
                      </p>
                    </div>
                  </Link>
                </motion.div>
              ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default UrunDetayPage;